import React from "react";
import "./RequiredLabel.scss";

export default function RequiredLabel() {
  return <span className="requiredSign">*</span>;
}